import animateScrollTo from 'animated-scroll-to'

const summary = {
  getHeadings: () => {
    const h2 = document.querySelectorAll('.TheContent h2')
    const h3 = document.querySelectorAll('.TheContent h3')
    return [...h2, ...h3]
  },

  setClassTitle: () => summary.getHeadings().map(item => item.classList.add('title-summary')),

  setIndexTitle: () => {
    const titles = document.querySelectorAll('.TheContent .title-summary')
    const list = Array.from(titles)

    list.map((item, index) => {
      item.id = `title-${index}`
    })

    return list
  },

  markup: ({ data }) => {
    return data
      .map(
        (item, index) => `
          <div class="Summary-item">
            ${item.tagName === 'H2' ? `<a class="Summary-item__title" href="#title-${index}">${item.textContent}</a>` : ''}
            ${item.tagName === 'H3' ? `<a class="Summary-item__sub-title" href="#title-${index}">${item.textContent}</a>` : ''}
          </div>
        `
      )
      .join('')
  },

  handleClick: ({ items, verticalOffset }) => {
    Array.from(items).map(item => {
      item.addEventListener('click', event => {
        event.preventDefault()
        const data = item.getAttribute('href')
        const section = document.querySelector(data)
        const active = document.querySelector('.Summary-item .active')

        if (active) {
          active.classList.remove('active')
        }

        item.classList.add('active')
        animateScrollTo(section, { verticalOffset: verticalOffset - 50, speed: 1000 })
      })
    })
  },

  init: () => {
    summary.setClassTitle()
    const isMobile = window.innerWidth < 576
    const verticalOffset = isMobile ? -65 : -100

    const data = summary.setIndexTitle()
    const block = document.querySelector('.Summary-content')

    if (!block) {
      return
    }

    block.innerHTML = summary.markup({ data })

    const items = document.querySelectorAll('.Summary-item a')
    summary.handleClick({ items, verticalOffset })
  }
}

summary.init()